'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ProgressTransferModal from 'LearningCenterUI/components/Modals/ProgressTransferModals/ProgressTransferModal';
import ProgressTransferConfirmationModal from 'LearningCenterUI/components/Modals/ProgressTransferModals/ProgressTransferConfirmationModal';
import ProgressTransferBanner from 'LearningCenterUI/components/Banners/ProgressTransferBanner';
import ProgressTransferVerifiedModal from 'LearningCenterUI/components/Modals/ProgressTransferModals/ProgressTransferVerifiedModal';
import { sendProgressTransferRequest } from 'LearningCenterUI/actions/ProgressTransferActions';
import UsageTracker from '../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
class ProgressTransferContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      destinationEmail: '',
      shouldShowConfirmationModal: false
    };
    this.handleSubmitDestinationAccount = this.handleSubmitDestinationAccount.bind(this);
    this.handleCloseConfirmationModal = this.handleCloseConfirmationModal.bind(this);
    this.handleConfirmProgressTransfer = this.handleConfirmProgressTransfer.bind(this);
    this.handleCloseVerifiedModal = this.handleCloseVerifiedModal.bind(this);
  }
  componentDidUpdate(prevProps) {
    const {
      isOpen
    } = this.props;
    if (prevProps.isOpen && isOpen !== prevProps.isOpen) {
      this.setState({
        destinationEmail: '',
        shouldShowConfirmationModal: false
      });
    }
  }
  handleSubmitDestinationAccount(email) {
    this.setState({
      destinationEmail: email,
      shouldShowConfirmationModal: true
    });
  }
  handleConfirmProgressTransfer() {
    this.props.sendProgressTransferRequest(this.state.destinationEmail);
  }
  handleCloseConfirmationModal() {
    this.setState({
      shouldShowConfirmationModal: false
    });
    this.props.handleClose();
  }
  handleCloseVerifiedModal() {
    this.props.onCloseVerification();
    this.props.handleClose();
  }
  render() {
    const {
      currentUserEmail,
      handleClose,
      isOpen,
      isRequestingProgressTransfer,
      progressTransferRequestCompleted,
      progressTransferVerified,
      recentError,
      verify,
      userAwards
    } = this.props;
    const {
      destinationEmail,
      shouldShowConfirmationModal
    } = this.state;
    if (verify) {
      return /*#__PURE__*/_jsx(ProgressTransferVerifiedModal, {
        error: recentError,
        onConfirm: this.handleCloseVerifiedModal,
        progressTransferVerified: progressTransferVerified
      });
    }
    if (progressTransferRequestCompleted) {
      UsageTracker.track('teamInteraction', {
        action: 'certswap-request-succeeded'
      });
      return /*#__PURE__*/_jsx(ProgressTransferBanner, {
        destinationEmail: destinationEmail
      });
    } else if (!isOpen) {
      return null;
    }
    if (shouldShowConfirmationModal) {
      return /*#__PURE__*/_jsx(ProgressTransferConfirmationModal, {
        certificates: userAwards,
        closeModal: this.handleCloseConfirmationModal,
        destinationEmail: destinationEmail,
        error: recentError,
        loading: isRequestingProgressTransfer,
        onConfirm: this.handleConfirmProgressTransfer,
        sourceEmail: currentUserEmail
      });
    }
    return /*#__PURE__*/_jsx(ProgressTransferModal, {
      currentEmail: currentUserEmail,
      onConfirm: this.handleSubmitDestinationAccount,
      onReject: handleClose
    });
  }
}
ProgressTransferContainer.propTypes = {
  currentUserEmail: PropTypes.string,
  handleClose: PropTypes.func,
  isOpen: PropTypes.bool,
  isRequestingProgressTransfer: PropTypes.bool,
  onCloseVerification: PropTypes.func,
  progressTransferRequestCompleted: PropTypes.bool,
  progressTransferVerified: PropTypes.bool,
  recentError: PropTypes.shape({
    status: PropTypes.number.isRequired
  }),
  sendProgressTransferRequest: PropTypes.func.isRequired,
  userAwards: PropTypes.array,
  verify: PropTypes.bool
};
function mapStateToProps(state) {
  const {
    auth: {
      user
    },
    progressTransfer
  } = state;
  return {
    currentUserEmail: user.email,
    hasError: progressTransfer.get('hasError'),
    isRequestingProgressTransfer: progressTransfer.get('isRequestingProgressTransfer'),
    isVerifyingProgressTransfer: progressTransfer.get('isVerifyingProgressTransfer'),
    progressTransferRequestCompleted: progressTransfer.get('progressTransferRequestCompleted'),
    recentError: progressTransfer.get('recentError'),
    progressTransferVerified: progressTransfer.get('progressTransferVerified')
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    sendProgressTransferRequest
  }, dispatch);
}
const ProgressTransferContainerConnect = connect(mapStateToProps, mapDispatchToProps)(ProgressTransferContainer);
export default ProgressTransferContainerConnect;